import React from 'react';
import ChangeLandingPage from '../change/landing/ChangeLandingPage';

export const RenewLandingPage = () => <ChangeLandingPage isRenewPage />;
